<template>
    <div class="contents">
        <rotaion :height="height" :route="this.$route.path" arrow="always" position=""></rotaion>
        <div>
            <img :src="img" alt="" />
        </div>
        <div class="center">
            <!-- ---------------------------game1 -->
            <div class="blue-top"></div>
            <div class="gameinfo" ref="ssss">
                <div
                    class="game1-left"
                    :style="{
                        transform: 'translateZ(1.75px) scale(.90) translateY(' + (trans - 100) + 'px) translateX(-200px)'
                    }"
                ></div>
                <div class="text-cls">
                    <div class="text-cls-top">轻松养成，重置无损，休闲护肝</div>
                </div>
                <div
                    class="game-right"
                    :style="{
                        transform: 'translateZ(1.75px) scale(.75) translateY(' + (trans - 300) + 'px) rotate(45deg) translateX(300px)'
                    }"
                ></div>
            </div>
            <!-- ---------------------------game2 -->
            <div class="gameinfo2">
                <div
                    class="game2-left"
                    :style="{
                        transform: 'translateZ(.25px) scale(.75) translateY(' + trans + 'px) rotate(-45deg) translateX(300px)'
                    }"
                ></div>
                <div class="text-cls" style="margin-left: 15rem">
                    <div class="text-cls-top">创新玩法，高燃弹射，爽快连击</div>
                </div>
                <div
                    class="game2-right"
                    :style="{
                        transform: 'translateZ(.25px) scale(.75) translateY(' + trans + 'px) translateX(100px)'
                    }"
                ></div>
            </div>
            <!-- ---------------------------game3 -->
            <div class="gameinfo3">
                <div
                    class="game3-left"
                    :style="{
                        transform: 'translateZ(.25px) scale(.75) translateY(' + trans + 'px) translateX(-200px)'
                    }"
                ></div>
                <div class="text-cls" ref="aaaa">
                    <div class="text-cls-top">离线放置，挂机收益，轻松突破</div>
                </div>
                <div
                    class="game3-right"
                    :style="{
                        transform: 'translateZ(.25px) scale(.75) translateY(' + (trans - 300) + 'px)  rotate(45deg) translateX(400px)'
                    }"
                ></div>
            </div>
        </div>
        <div class="main-bussiness">主营业务</div>
        <ul class="bussiness-list">
            <li class="bussiness-item">
                <p>提供基于IT基础设施、终端设备及应用系统的综合运维交付服务，同时持续通过＋人工智能与服务机器人、＋云计算与大数据、＋移动互联网与物联网等技术与工具。</p>
                <div>IT综合运维服务</div>
            </li>
            <li class="bussiness-item">
                <p>面向行业及大客户，自主创新，走向全国，开发通用、专用软件，提供以综合运维服务管控为主，兼顾政府政务、企业业务及智慧城市应用的软件开发及服务。</p>
                <div>服务管理软件开发及服务</div>
            </li>
            <li class="bussiness-item">
                <p>以IT综合服务为基础，逐步向泛IT服务拓展，面向中小企业及家庭客户，提供基于云计算与大数据、移动互联网与物联网技术的SaaS服务平台运营模式。</p>
                <div>泛IT云智能服务平台</div>
            </li>
        </ul>
        <bottom></bottom>
    </div>
</template>

<script>
import rotaion from './components/rotation';
import bottom from './components/bottom';
export default {
    components: { rotaion, bottom },
    data() {
        return {
            img: require('@/common/imgs/game-logo.png'),
            height: window.innerHeight,
            trans: 100,
            trans2: 0,
            i: 0,
            dynamic: [
                {
                    image: 'https://game-cdn.feigo.fun/uploads/20201202/zMHOEg26v3dCKogCyP1rTaSP1et1iQM5.png',
                    name: '《超级坦克王》：',
                    content:
                        '超级坦克王是一款酷炫的坦克题材游戏，双方轮流开炮，生命条消耗完的一方失败，游戏里有各种技能不同的坦克，左手控制坦克移动，右手瞄准发射炮弹，精美的卡通游戏画风，酷炫的技能特效，再加上音效和震动配合，玩起来体验极好。'
                },
                {
                    image: 'https://game-cdn.feigo.fun/uploads/20201202/jDszvAbFwiVHE69FRr4U39H5HEceVBLF.png',
                    name: '《天梯跑酷》：',
                    content: '酷酷的小机甲，在楼顶凭梯纵跃，看谁才是玩伸缩梯的真正高手。'
                },
                {
                    image: 'https://game-cdn.feigo.fun/uploads/20201202/PE9vQVPNnezIdr2nDaCdIlXYyGdQA3hs.png',
                    name: '《竞速车神》：',
                    content:
                        '竞速车神是一款超级刺激、解压的卡丁车竞速游戏，玩家控制着在赛车，在海滨公路上极速狂飙；更是可超控导弹技能对敌人的战车进行狂轰滥炸，同时利用护盾技能拦截敌人的火炮，勇夺第一，快来一起体验极速竞技的快感，释放你的无限激情！'
                }
            ]
        };
    },
    methods: {
        handleScroll(event) {
            let top = this.$refs.ssss.getBoundingClientRect().top;
            let top2 = this.$refs.aaaa.getBoundingClientRect().top;
            var scrollTop = window.pageYOffset;
            var scroll = scrollTop - this.i;
            this.i = scrollTop;
            if (-this.height < top < this.height) {
                if (scroll < 0) {
                    this.trans = top / 5 + 200;
                } else {
                    this.trans = top / 5 + 200;
                }
            }
        },
        goList() {
            this.$router.push('/productList');
        },
        goGameDetail(index) {
            this.$router.push({
                path: '/aboutGame',
                query: {
                    index
                }
            });
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
};
</script>

<style src="./css/home.css"></style>
